// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1zQyt","rootSuccess":"CompleteLink_rootSuccess__28MKR","rootFailure":"CompleteLink_rootFailure__2ZWOr","isDisabled":"CompleteLink_isDisabled__3zkkr"};